<template>
  <div>
    <future-operations-grid v-bind="$attrs" ref="operationsGrid" />
  </div>
</template>

<script>
import FutureOperationsGrid from './FutureOperationsGrid'

export default {
  inheritAttrs: false,
  components: {
    FutureOperationsGrid,
  },
  methods: {
    isEmpty() {
      return this.$refs.operationsGrid.isEmpty()
    },
    async validate() {
      const validation = this.$refs.operationsGrid.validate()
      if (validation.length) {
        return validation
      }

      return []
    },
    cancelChanges() {
      this.$refs.operationsGrid.cancelGridChanges()
    },
  },
}
</script>
